import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { isNil } from 'lodash';
import { useSnackbar } from 'notistack';
import { CompaniesService } from 'api/services/CompaniesService';
import {
  COMPANY_NEWS_DEFAULT_ERROR_MESSAGE,
  COMPANY_NEWS_QUERY_KEY,
} from 'common/constants/services/companies';

const useGetCompanyNews = (companyId: number | undefined, pageAfter?: string) => {
  const { enqueueSnackbar } = useSnackbar();

  const { data, isLoading, isFetching, isError } = useQuery({
    enabled: !isNil(companyId),
    queryFn: () => CompaniesService.apiCompaniesNewsRead(companyId as number, pageAfter),
    queryKey: [COMPANY_NEWS_QUERY_KEY, companyId, pageAfter],
    retry: false,
  });

  useEffect(() => {
    if (isError) {
      enqueueSnackbar(COMPANY_NEWS_DEFAULT_ERROR_MESSAGE, { variant: 'error' });
    }
  }, [isError, enqueueSnackbar]);

  return { data, isLoading, isFetching, isError };
};

export default useGetCompanyNews;
